import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/checkout';
import { PRODUCT_NAME } from '../data/brand';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  /** 'checkout' opens the payment page, 'offer' scrolls to the offer section. */
  target?: 'checkout' | 'offer';
}
export function CtaButton({
  children,
  size = 'md',
  fullWidth = false,
  target = 'checkout'
}: CtaButtonProps) {
  const isCheckout = target === 'checkout';
  // InitiateCheckout is fired by the checkout page itself on load — only track ViewContent here.
  const handleClick = isCheckout ? undefined : (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackPixelEvent('ViewContent', {
      content_name: `${PRODUCT_NAME} — Kompletny pakiet`,
      value: 35,
      currency: 'USD'
    });
    const offer = document.getElementById('offer');
    if (!offer) return;
    event.preventDefault();
    scrollToOffer(offer);
  };
  return <a href={isCheckout ? CHECKOUT_URL : '#offer'} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-lg bg-amber text-center font-bold uppercase leading-tight tracking-[0.08em] text-night transition-[background-color,transform] duration-150 ease-out hover:bg-amber-light active:translate-y-px ${size === 'lg' ? 'px-6 py-4 text-sm sm:px-9 sm:py-5 sm:text-base' : 'px-5 py-3 text-xs sm:px-7 sm:py-4 sm:text-sm'} ${fullWidth ? 'w-full' : ''}`} data-id="element-88" data-mp="39y7y82d1fe7m">
      {children}
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-89" data-mp="1l0wo87xfkit" />
    </a>;
}

/**
 * Scrolls to the offer section and re-checks once images above it have loaded,
 * so late layout shifts can't leave the visitor sitting on a different section.
 */
function scrollToOffer(offer: HTMLElement) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  offer.scrollIntoView({
    behavior: reduceMotion ? 'auto' : 'smooth',
    block: 'start'
  });
  const correct = () => {
    const top = offer.getBoundingClientRect().top;
    if (Math.abs(top) > 40) offer.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    });
  };
  window.setTimeout(correct, 700);
  window.setTimeout(correct, 1400);
}